module.exports = __webpack_public_path__ + "assets/svg/UI/education-create-shift-c161f0.svg";